export function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      style={{ color: "var(--neutral-on-tonal)" }}
      aria-hidden="true"
    >
      <path
        d="M10.8294 7.582C11.0569 7.81288 11.0569 8.1862 10.8294 8.41462L5.99073 13.3268C5.76331 13.5577 5.39556 13.5577 5.17056 13.3268C4.94556 13.096 4.94315 12.7226 5.17056 12.4942L9.59798 7.99954L5.17056 3.50486C4.94315 3.27398 4.94315 2.90065 5.17056 2.67224C5.39798 2.44382 5.76573 2.44136 5.99073 2.67224L10.8294 7.58446V7.582Z"
        fill="currentColor"
      />
    </svg>
  );
}
